import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import { configStore } from './store/configStore'
import './helpers/i18n'
import './main.scss'
import reportWebVitals from './reportWebVitals'
import { AppConnectRoutes } from './navigation/AppConnectRoutes'
import { setupSentry } from 'helpers'
import * as Sentry from '@sentry/react'
import { MatomoProvider, createInstance } from '@jonkoops/matomo-tracker-react'
import { AppModalProvider, ErrorFallback } from './components'
import { GoogleOAuthProvider } from '@react-oauth/google'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
const configStores = configStore()

if (process.env.REACT_APP_SENTRY_DSN) {
    setupSentry({
        dsn: process.env.REACT_APP_SENTRY_DSN,
        environment: process.env.REACT_APP_ENVIRONMENT,
        version: process.env.REACT_APP_APP_VERSION
    })
}

const instance = createInstance({
    urlBase: process.env.REACT_APP_MATOMO_URL || '',
    siteId: parseInt(process.env.REACT_APP_MATOMO_SITE_ID || '10'),
    linkTracking: false, // Important!
    disabled: !process.env.REACT_APP_MATOMO_URL
})

root.render(
    <React.StrictMode>
        <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
            <GoogleOAuthProvider
                clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ''}
            >
                <Provider store={configStores}>
                    <MatomoProvider value={instance}>
                        <AppModalProvider>
                            <AppConnectRoutes />
                        </AppModalProvider>
                    </MatomoProvider>
                </Provider>
            </GoogleOAuthProvider>
        </Sentry.ErrorBoundary>
    </React.StrictMode>
)

// register offline pwa
serviceWorkerRegistration.register()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

// When the storage is cleared, the app will be unable to function correctly
// and the user should be redirected to the home page
window.addEventListener(
    'storage',
    (event) => {
        if (
            event.key === null &&
            event.oldValue === null &&
            event.newValue === null
        ) {
            window.location.href = '/'
        }
    },
    { once: true }
)
